import { render, staticRenderFns } from "./AddCardScreen.vue?vue&type=template&id=054c19c7&"
import script from "./AddCardScreen.vue?vue&type=script&lang=js&"
export * from "./AddCardScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports